module.exports = __webpack_public_path__ + "img/SIP_logo@3x.2d599ba1.png";